import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { AppComponent } from '../app.component';
import { Batiment } from '../Models/Batiment';
import { cloneDeep, cloneDeepWith } from "lodash";
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-modal-meubles-cuisine',
  templateUrl: './modal-meubles-cuisine.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./modal-meubles-cuisine.component.less']
})
export class ModalMeublesCuisineComponent implements OnInit {
  globalTxt: any;
  modalsTxt: any;
  collapsing = true;
  modalInfo: any;
  avecIlot: boolean = false;

  batiment: Batiment = JSON.parse(localStorage.getItem("BATIMENT")!);
  paramPicId = -1;
  // ==> A faire dynamiquement
  objPicPiece: any = null;
  iniSimulationGetCuisineMto: any = null;

  prixTotalMobCuisine: any = 842; //API pour calculer et recup le prix total des meubles. Aussi appeler cette api au ng change dans les inputs quantité

  constructor(
    public app: AppComponent,
    private activatedRoute: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    // ==> On recupere la modalInfo en cours from data-tools pour pouvoir acceder à la fonction qui ferme la modal
    this.app.dataToolsService.currentModalInfo.subscribe(modalInfo => {
      //console.log("modalInfo  => ", modalInfo);
      this.modalInfo = modalInfo;

      this.getInfosInit();
    });
  }

  getInfosInit() {
    let modalData = JSON.parse(localStorage.getItem('modalOpen')!);
    this.paramPicId = (modalData) ? modalData.data : null;
    console.log(this.paramPicId);

    // ==> On GET le JSON des Textes globaux
    this.app.dataToolsService.currentGlobalTexts.subscribe(object => {

      // ==> Si l'objet n'est pas encore défini dans les dataTools, alors on appele la fonction dans sharedTools pour remplir l'objet dans les dataTools
      if (!object)
        this.app.sharedToolsService.getGlobalTexts();

      this.globalTxt = object;

      // ==> On CALL les textes des modals
      this.app.sharedToolsService.getJSON('txtModals').subscribe(resp => {
        console.log("resp ==> ", resp);
        this.modalsTxt = cloneDeep(resp.meublesCuisine);

        // ==> on recup l'objet piece by API GET
        this.getObjPieceCuisine();
      })
    });
  }

  getObjPieceCuisine() {
    if (this.paramPicId < 1) {
      //alert("picId is missing !");
      return;
    }

    this.app.apiToolsService.simulationGetCuisineMtoGet(this.paramPicId, 6).subscribe((resp: any) => {
      console.log("resp simulationGetCuisineMtoGet ==> ", resp);

      if (resp == null) {
        //alert("resp is null !");
        return;
      }

      this.iniSimulationGetCuisineMto = cloneDeep(resp);

      // ==> A faire dynamiquement avec une APi de GET
      this.objPicPiece = {
        PIC_CONFIG_ID: resp.PICFC_ID,
        PIC_DIMENSION: resp.PIC_METRE_LINEAIRE,
        PIC_STANDING: resp.PIC_STANDING,
        arrMobilier: [
          {
            typeMeuble: 1, //haut
            qte: resp.PIC_NB_MEUBLE_HAUT,
            prop: "PIC_NB_MEUBLE_HAUT"
          },
          {
            typeMeuble: 2, //colonne
            qte: resp.PIC_NB_MEUBLE_COLONNE,
            prop: "PIC_NB_MEUBLE_COLONNE"
          },
          {
            typeMeuble: 3, //bas
            qte: resp.PIC_NB_MEUBLE_BAS,
            prop: "PIC_NB_MEUBLE_BAS"
          },
          {
            typeMeuble: 4, //ilot
            qte: resp.PIC_NB_MEUBLE_BAS_ILOT,
            prop: "PIC_NB_MEUBLE_BAS_ILOT"
          },
        ],
        listElectromenager: cloneDeep(resp.listElectromenager)
      }
      console.log("this.objPicPiece ==>", this.objPicPiece);

      setTimeout(() => {
        this.avecIlot = (this.objPicPiece.arrMobilier[3].qte > 0);
      }, 1);
    });
  }

  // ==> Fonction pour recup l'image pour la dimension selon le PIC_CONFIG_ID
  getPicImgDimensionByConfigId(_configId: any) {
    if (!_configId) return '';

    let nameImg: string = 'meuble' + _configId.toString() + '.svg';
    return '/assets/images/pictos/' + nameImg;
  }

  onClickPanel(_step: any, _id: any) {
    _step.show = !_step.show;

    let id = document.getElementById(_id);
    //console.log(id);

    if (id) {
      id.classList.toggle("show");
    }
  }

  onAvecIlot() {
    this.objPicPiece.arrMobilier[3].qte = (this.avecIlot) ? 4 : 0;
    return false;
  }

  onRating(_item: any, _model: any, _optValue: any) {
    _item[_model] = _optValue;
  }

  getIfTabMobIsOk() {
    let boolIsOk: boolean = false;
    let arrObjsQteIsPlusDeZero: any = this.objPicPiece.arrMobilier.filter((mob: any) => { return mob.qte > 0; });

    boolIsOk = arrObjsQteIsPlusDeZero.length < 1 ? false : true;

    return boolIsOk;
  }

  showErrorAlertMsgInTable() {
    let boolShowMsg: boolean = false;
    boolShowMsg = (!this.getIfTabMobIsOk()) ? true : false;

    return boolShowMsg;
  }

  validate() {
    // ==> Sécurité pour RETURN si la QTE dans tous les objets mob est 0
    if (!this.getIfTabMobIsOk()) {
      //this.showErrorAlertMsgInTable();
      return;
    }

    console.log("this.objPicPiece ==>", this.objPicPiece);

    //conversion
    this.iniSimulationGetCuisineMto.PICFC_ID = this.objPicPiece.PIC_CONFIG_ID;
    this.iniSimulationGetCuisineMto.PIC_METRE_LINEAIRE = this.objPicPiece.PIC_DIMENSION;
    this.iniSimulationGetCuisineMto.PIC_STANDING = this.objPicPiece.PIC_STANDING;
    this.iniSimulationGetCuisineMto.PIC_NB_MEUBLE_HAUT = this.objPicPiece.arrMobilier[0].qte;
    this.iniSimulationGetCuisineMto.PIC_NB_MEUBLE_COLONNE = this.objPicPiece.arrMobilier[1].qte;
    this.iniSimulationGetCuisineMto.PIC_NB_MEUBLE_BAS = this.objPicPiece.arrMobilier[2].qte;
    this.iniSimulationGetCuisineMto.PIC_NB_MEUBLE_BAS_ILOT = this.objPicPiece.arrMobilier[3].qte;
    this.iniSimulationGetCuisineMto.listElectromenager = cloneDeep(this.objPicPiece.listElectromenager);

    console.log("this.iniSimulationGetCuisineMto ==>", this.iniSimulationGetCuisineMto);

    this.app.apiToolsService.simulationGetCuisineMtoSet(this.paramPicId, 6, this.iniSimulationGetCuisineMto).subscribe((resp: any) => {
      console.log("resp simulationGetCuisineMtoSet ==> ", resp);

      // ==> Ici on reload la page
      if (resp == 'OK') location.reload();
    });

    // ==> Ici on ferme la modal = NON ! C'est mieux le reload
    //this.modalInfo.noFn();
  }
}
